import SpeakerList from "./SpeakerList";

export * from "./SpeakerList";
export default SpeakerList;
